<template>
  <div>
    <div class="houseDeposit">
      <bv-top></bv-top>
      <van-cell-group>
        <van-cell title="姓名" :value="owner.signName" />
<!--        <van-cell title="证件类型" :value="owner.signCardType" />-->
        <van-cell title="证件类型" :value="'身份证'" />
        <van-cell title="证件号码" :value="owner.signCardNo" />
        <van-field
            name="ownerName"
            v-model.trim="owner.signMobile"
            clearable
            label="手机号"
            placeholder="请输入业主手机号"
        />
      </van-cell-group>
      <van-row type="flex" justify="center">
        <van-col span="14">
          <van-button type="primary" size="large" :disabled="isButtonDisabled" @click="signCommit()" >确认</van-button>
        </van-col>
      </van-row>
      <van-row type="flex" justify="center">
        <van-col span="20">
          <p><span class="u46_div">尊敬的用户，请确认手机号为本人手机号且正常使用，若手机号无法正常使用，请修改手机号。若您已在e签宝注册，请务必填写e签宝注册的手机号，否则无法完成签署。</span></p>
        </van-col>
      </van-row>
    </div>
<!--    <div  class="u46">-->
<!--      <div class="u46text" >-->
<!--        -->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {signerChack,signCommit,updateESignMobile} from '@/api/maintainFund/maintainFund'
    import Top from '@/views/components/Top'
import {Dialog} from "vant";
    export default {
        name: "signUserMessage",
        data() {
            return {
              owner: {},
              regionName: '',
              regionSearchName: '',
              regionNo: '',
              onLineDeposit: '',
              showFlag:false,
              localSignName : ''
            }
        },
      computed: {
        // 计算属性：判断按钮是否应该禁用
        isButtonDisabled() {
          // 如果证件号码为空或者showFlag为true，则禁用按钮
          return !this.owner.signCardNo || this.showFlag;
        }
      },
        mounted() {
          let owner = this.$route.query.owner;
          this.owner = owner
          console.log(owner)
          this.showFlag = false;
        },

        components: {
            BvTop: Top,
        },
        methods: {
          signCommit() {
            if (this.isButtonDisabled) return;
            this.showFlag = true
            signerChack(this.owner).then(res => {
              if (res.data.code === '0001') {
                Dialog.confirm({
                  title: '提示',
                  message: '查询到您已在e签宝注册\n' +
                      '\n' +
                      '是否将e签宝已绑定手机号改为当前手机号？\n' +
                      '\n' +
                      '当前填写的手机号：' + res.data.commitMobile + '\n' +
                      '\n' +
                      'e签宝当前手机号：' + res.data.loginMobile + '\n',
                }).then(() => {
                  let update = {
                      signMobile:res.data.commitMobile,
                      signCardNo:this.owner.signCardNo
                  }
                  updateESignMobile(update).then(res3 =>{
                    console.log(res3)
                  })
                }).catch(() => {

                })
              } else if (res.data.code === '0008') {
                Dialog.confirm({
                  title: '提示',
                  message: '查询到您已在e签宝注册并实名\n' +
                      '\n' +
                      '当前填写的手机号：' + res.data.commitMobile + '\n' +
                      '\n' +
                      'e签宝实名手机号：' + res.data.loginMobile + '\n' +
                      '\n' +
                      '若需改为当前填写的手机号信息\n' +
                      '\n' +
                      '请前往e签宝平台进行修改'
                }).then(() => {
                  this.isShow = true;
                }).catch(() => {
                  this.$toast.clear();
                })
              } else if (res.data.code === '0000') {  // 签署完成
                this.owner.outerAccountId = res.data.outerAccountId
                console.log(this.owner)
                signCommit(this.owner).then(res2 => {
                  if (res2.data.retCode === '0000') {  // 签署完成
                    sessionStorage.setItem('depAgreeId', res2.data.eSignRespose.depAgreeId);
                    sessionStorage.setItem('signUrl', res2.data.eSignRespose.signUrl);
                    console.log(8989898989)
                    console.log(res2.data)
                    console.log(res2.data.eSignRespose.depAgreeId)
                    this.$router.push({
                      path: '/onlineDeposit/signChild/waitSign',
                      query: {label: '等待交存约定书签署', depositApply: res2.data}
                    })
                  }
                })
              }
            })
          }
        }
    }
</script>

<style lang='scss' scoped>
    .houseDeposit {
        height: 100vh;
        background: #f2f2f2;

        .btn {
            margin-top: 5%;
            border-radius: 5px;
            background-color: #2acba2 !important;
            border: 1px solid #2acba2 !important;
        }

        .footFont {
            font-weight: normal;
            font-size: 14px;
            color: #999;
        }
    }

    .regionList {
        z-index: 100;
        position: absolute;
        width: 100%;
        margin-left: 25%;
        display: inline !important;
        list-style: none;
        overflow-y: scroll;
        line-height: 2;
        border-radius: 6px;
        background: white;

    }
    .u46_div {
      border-width: 0px;
      height: 80px;
      background: inherit;
      background-color: rgba(250, 205, 145, 0.2980392156862745);
      border: none;
      border-radius: 0px;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      font-size: 13px;
      color: #F59A23;
      text-align: left;
    }
</style>
